import {PositionWithUsersAndRights} from "../../types/api/authorization/position.types";
import {positionService} from "../../services/authorization/position-service";
import {useFetch} from "../useFetch";

export const useFetchAllPositions = () => {
    const { isLoading, error, data, refetch } = useFetch<PositionWithUsersAndRights[]>(positionService.getAll);

    return {data: data || [], isLoading, error, refetch};
}